import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';

function ComposerDropOverlay() {
    return (
        <div className="pointer-events-none absolute -inset-px z-10 flex items-center justify-center gap-2 rounded-xl border-2 border-dashed border-blue-400 bg-blue-50/90 text-sm font-medium text-blue-700">
            <ArrowUpTrayIcon className="w-5 h-5" aria-hidden="true" />
            Drop to attach
        </div>
    );
}

export { ComposerDropOverlay };
